import { useEffect } from "react";
import { NextSeo } from "next-seo";
import dynamic from "next/dynamic";
import StoreProvider from "@/store/StoreProvider";
import { NextApiRequest } from "next";
import { SessionPayload } from "@/store";
import {
  getSessionAndWorkflow,
  advanceStep,
  SuccessResponse,
} from "./api/session/actions";

const AppWrapper = dynamic(() => import("@/components/AppWrapper"));
const DevDashboard = dynamic(() => import("@/components/DevDashboard"));

const DEVELOPER_MODE = process.env.NEXT_PUBLIC_DEVELOPER_MODE || false;

export async function getServerSideProps(request: NextApiRequest) {
  const { sessionId } = request.query;
  let sessionExpired = false;

  let output = {} as SessionPayload;
  if (sessionId) {
    const result = await getSessionAndWorkflow(String(sessionId));
    if ("status" in result && result.status === 401) {
      sessionExpired = true;
    }
    let { user, session, workflow } = result as SuccessResponse;

    const incomingSuccess = request?.query?.success;
    if (incomingSuccess) {
      if (workflow?.state) {
        workflow = await advanceStep(workflow, String(incomingSuccess));
      } else {
        // just dev warning/rant
        console.log(
          `SUCCEED: Would love to tag step ${incomingSuccess} as success.`,
        );
        console.log(
          `SUCCEED: However, this app is built with clientside-first logic and we need useSetWorkflowState() to run client side to populate state in db.`,
        );
        console.log(
          `SUCCEED: After this first load, try rerunning "&success=${incomingSuccess}"`,
        );
      }
    }

    if (user && session?.uuid) {
      output = {
        user,
        session,
        workflow,
      };
    }
  }
  // console.log("HOME", output);
  return { props: JSON.parse(JSON.stringify({ ...output, sessionExpired })) };
}

export default function Home({
  user,
  session,
  sessionExpired,
  workflow,
}: {
  user: any;
  session: any;
  sessionExpired: boolean;
  workflow: any;
}) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.has("success")) {
      params.delete("success");
      const qs = params.toString();
      window.history.replaceState(
        {},
        "",
        qs ? `?${qs}` : window.location.pathname,
      );
    }
  }, []);

  return (
    <StoreProvider>
      <NextSeo
        title="Mastermind Business Academy | Onboarding"
        description="Mastermind Business Academy onboarding"
      />
      <AppWrapper
        user={user}
        session={session}
        sessionExpired={sessionExpired}
        workflow={workflow}
      />
      {DEVELOPER_MODE ? <DevDashboard /> : ""}
    </StoreProvider>
  );
}
